<template>
  <div>
    <app-loading v-bind:loading="loading"></app-loading>
    <div class="container spechomes-list">
      <app-package-filter v-if="hnlSummaryList.length" v-bind:hnlSummaryList="hnlSummaryList" v-on:filteredPackages="filteredHnlList=$event" v-on:tileView="tileView = $event"></app-package-filter>
      <div class="columns is-multiline is-variable is-6" v-if="filteredHnlList && tileView">
        <div class="column is-3-widescreen is-4-desktop is-6-tablet is-12-mobile"
             v-for="hnlSummary in filteredHnlList">
          <app-package-card :isFavorite="favoriteHnl && favoriteHnl.includes(hnlSummary.cpidstring)" v-bind:hnlSummary="JSON.parse(JSON.stringify(hnlSummary))"></app-package-card>
        </div>
      </div>
    </div>
      <app-spec-map :filteredHnlList="filteredHnlList" v-if="!tileView && filteredHnlList"></app-spec-map>
  </div>
</template>

<script>

import PackageCard from "@/components/journey/spec/PackageCard";
import Loading from "@/components/journey/Loading";
import PackageFilter from "@/components/journey/spec/PackageFilter";
import SpecMap from "@/components/journey/spec/SpecMap";

export default {

  name: 'app-map',
  mixins: [],
  components: {
    'app-package-card': PackageCard,
    'app-package-filter': PackageFilter,
    'app-spec-map': SpecMap,
    'app-loading': Loading
  },
  data() {
    return {
      favoriteHnl: [],
      filteredHnlList: null,
      hnlSummaryList: [],
      loading: true,
      sub: null,
      tileView: true,
    }
  },
  watch: {
  },
  mounted() {
    const list = this.$store.state.communityStore.specHomesList;
    if (list && list.length) {
      this.hnlSummaryList = list;
      this.loading = false
    } else {
      this.$store.dispatch('getSpecHomesList');
    }
    this.favoriteHnl = this.$store.state.favoriteStore.favoriteHnl;

    this.sub = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setSpecHomesList') {
        this.hnlSummaryList = state.communityStore.specHomesList;
        this.filteredHnlList = this.hnlSummaryList;
        this.loading = false;
        this.$emit('homesLoaded', true);
      }

      if (mutation.type === "setFavoriteHnl") {
        this.favoriteHnl = state.favoriteStore.favoriteHnl;
      }
    });
  },
  beforeDestroy() {
    this.sub();
  },
  methods: {
    selectHome: function (hnlSummary) {
      this.activeHome = hnlSummary;
    },

    nextPage: function (ev) {
      this.activeHomeDetail = ev;
      this.$emit('goNext', true);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/spec/Spec.vue